module.exports = __webpack_public_path__ + "img/05.f7aae7e0.png";